import Paragraph from "@components/Paragraph";
import Spacer from "@components/Spacer";
import CustomImage from "@components/custom-image";
import { roundness } from "@provider/dripsy";
import { H3, H4, View } from "dripsy";
import * as React from "react";

function SupplierItem({
  name,
  company,
  bio,
  image,
  mt = "$2",
}: {
  name: string;
  company?: string;
  bio: string;
  image: any;
  mt?: "$2" | 0;
}) {
  return (
    <View sx={{ flexDirection: ["column", "row"], mt }}>
      <CustomImage
        source={{ uri: image }}
        sx={{ width: 140, height: 140, borderRadius: roundness, marginRight: "$2", marginBottom: ["$2", 0] }}
        alt={name}
      />
      <View sx={{ flexDirection: "column", flex: 1 }}>
        <H3 sx={{ fontWeight: "600", mb: "$1", mt: 0 }}>{name}</H3>
        {company ? (
          <>
            <H4 sx={{ fontWeight: "400", color: "$textGrey", mt: 0, mb: 0 }}>{company}</H4>
          </>
        ) : null}
        <Spacer size="$1" />
        <Paragraph notTooLarge>{bio}</Paragraph>
      </View>
    </View>
  );
}
export default SupplierItem;
